import { render } from "./SlidesOnly.vue?vue&type=template&id=61689d7a&ts=true"
import script from "./SlidesOnly.vue?vue&type=script&lang=ts"
export * from "./SlidesOnly.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__